export default __webpack_public_path__ + "static/media/favicon.82695ab1.ico";